"use client";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { ApolloProvider } from "./ApolloProvider";
import { FeatureAnnouncementProvider } from "@/hooks/featureAnnouncement/useFeatureAnnouncement";
import { NotificationPreferencesProvider } from "@/context/NotificationPreferencesContext";
import { PageScrollProvider } from "./PageScrollProvider";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { ShortLinkProvider } from "./ShortLinkProvider";
import { Suspense } from "react";
import { TixologiWidgetProvider } from "@/hooks/tixologi/widget";
import { UserRolesProvider } from "./UserRolesProvider";

const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false } },
});

/*
 * This component is used to render all the providers that are used globally in our app.
 */
function Providers({ children }: { children: React.ReactNode }) {
  return (
    <Suspense>
      <ShortLinkProvider>
        <QueryClientProvider client={queryClient}>
          <ApolloProvider>
            <TixologiWidgetProvider>
              <FeatureAnnouncementProvider>
                <NotificationPreferencesProvider>
                  <UserRolesProvider>
                    <PageScrollProvider>{children}</PageScrollProvider>
                  </UserRolesProvider>
                </NotificationPreferencesProvider>
              </FeatureAnnouncementProvider>
            </TixologiWidgetProvider>
          </ApolloProvider>
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
      </ShortLinkProvider>
    </Suspense>
  );
}
export default Providers;
